
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60","viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M54.994 22.481v15.018c0 6.257-1.251 10.638-4.055 13.466L34.97 34.996l19.348-19.348a30.793 30.793 0 01.676 6.833z","fill":"none","stroke":"#bac1cc","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"3"}}),_c('path',{attrs:{"d":"M54.318 15.678l-38.64 38.64c-7.523-1.724-10.672-6.923-10.672-16.82v-15c0-12.492 5-17.492 17.5-17.492h15c9.889 0 15.088 3.149 16.812 10.672z","fill":"none","stroke":"#bac1cc","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"3"}}),_c('path',{attrs:{"d":"M50.965 50.939c-2.828 2.8-7.209 4.055-13.466 4.055H22.481a30.793 30.793 0 01-6.833-.676L34.996 34.97z","fill":"none","stroke":"#bac1cc","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"3"}}),_c('path',{attrs:{"d":"M15.595 19.95c1.7-7.334 12.715-7.334 14.417 0 .976 4.305-1.727 7.959-4.1 10.212a4.507 4.507 0 01-6.207 0c-2.383-2.252-5.111-5.907-4.11-10.212z","fill":"none","stroke":"#bac1cc","stroke-width":"3","opacity":".4"}}),_c('path',{attrs:{"d":"M22.737 21.75h.022","fill":"none","stroke":"#bac1cc","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"3","opacity":".4"}})])
          )
        }
      }
    